import React from 'react';
import { Clock } from 'lucide-react';
import AmPmTimeInput from './AmPmTimeInput';
import './OperatingHoursSection.css';

/**
 * F2 — Operating hours section for the Booking rules card.
 *
 * Mockup layout: single outer bordered container holding both WEEKDAY
 * and WEEKEND blocks side-by-side. Each block has an overline label
 * (`WEEKDAY` / `WEEKEND`) followed by a colored day-range pill
 * (`MON-FRI` / `SAT-SUN`).
 *
 * Decision (per microphase plan §1): the SAT-SUN pill uses the neutral
 * `--ap-surface-muted` token instead of the mockup's blue, to stay
 * within the project's pure-black + neon-green palette.
 */
const OperatingHoursSection = ({
  weekdayOpen,
  weekdayClose,
  weekendOpen,
  weekendClose,
  disabled = true,
  onTimeChange,
  footnote = 'Applied to appointment availability. Individual services can open later or close earlier below.',
}) => (
  <div className="appointments-v3-hours">
    <div className="appointments-v3-hours-overline">
      <Clock size={12} aria-hidden="true" />
      <span>OPERATING HOURS</span>
    </div>
    <div className="appointments-v3-hours-frame">
      <div className="appointments-v3-hours-block">
        <div className="appointments-v3-hours-block-head">
          <span className="appointments-v3-hours-block-label">WEEKDAY</span>
          <span className="appointments-v3-hours-chip appointments-v3-hours-chip-weekday">
            MON-FRI
          </span>
        </div>
        <div className="appointments-v3-hours-row">
          <AmPmTimeInput
            value={weekdayOpen || ''}
            disabled={disabled}
            ariaLabel="Weekday opening time"
            leadingIcon
            onChange={(nextValue) => onTimeChange?.('weekdayOpen', nextValue)}
          />
          <span className="appointments-v3-hours-sep">to</span>
          <AmPmTimeInput
            value={weekdayClose || ''}
            disabled={disabled}
            ariaLabel="Weekday closing time"
            leadingIcon
            onChange={(nextValue) => onTimeChange?.('weekdayClose', nextValue)}
          />
        </div>
      </div>

      <div className="appointments-v3-hours-block">
        <div className="appointments-v3-hours-block-head">
          <span className="appointments-v3-hours-block-label">WEEKEND</span>
          <span className="appointments-v3-hours-chip appointments-v3-hours-chip-weekend">
            SAT-SUN
          </span>
        </div>
        <div className="appointments-v3-hours-row">
          <AmPmTimeInput
            value={weekendOpen || ''}
            disabled={disabled}
            ariaLabel="Weekend opening time"
            leadingIcon
            onChange={(nextValue) => onTimeChange?.('weekendOpen', nextValue)}
          />
          <span className="appointments-v3-hours-sep">to</span>
          <AmPmTimeInput
            value={weekendClose || ''}
            disabled={disabled}
            ariaLabel="Weekend closing time"
            leadingIcon
            onChange={(nextValue) => onTimeChange?.('weekendClose', nextValue)}
          />
        </div>
      </div>
    </div>

    <p className="appointments-v3-hours-foot">
      {footnote}
    </p>
  </div>
);

export default OperatingHoursSection;
